/**
 * Build a short human-readable summary from chat match search params.
 */

export function toPreferenceLabel(item, depth = 0) {
  if (item == null || item === "" || depth > 4) return "";
  if (typeof item === "string" || typeof item === "number") {
    const text = String(item).trim();
    return text === "[object Object]" ? "" : text;
  }
  if (typeof item === "object") {
    return toPreferenceLabel(
      item.label ?? item.name ?? item.value ?? item.useCase,
      depth + 1,
    );
  }
  return "";
}

export function buildSearchContextSummary(searchParams) {
  if (!searchParams) return null;

  const parts = [];

  const constraint =
    typeof searchParams.productConstraint === "string"
      ? searchParams.productConstraint.trim()
      : String(searchParams.productConstraint?.label || "").trim();
  if (constraint) parts.push(constraint);

  const useCase = toPreferenceLabel(searchParams.useCase);
  if (useCase) {
    parts.push(useCase);
  }

  (searchParams.mustHaves || []).slice(0, 2).forEach((item) => {
    const label = toPreferenceLabel(item);
    if (label && !parts.includes(label)) parts.push(label);
  });

  if (searchParams.budget?.max != null) {
    const max = Number(searchParams.budget.max);
    if (Number.isFinite(max)) {
      parts.push(`up to $${max.toLocaleString()}`);
    }
  }

  return parts.length > 0 ? parts.join(", ") : null;
}
